export var environment = {
    production: true,
    environment: 'prod',
    apiUrl: 'https://tf.gopiqiu.com',
    appTitle: '论文格式处理工具',
    uploadMaxSize: 100, // MB
    enableDebug: false,
    logLevel: 'error',
    apiTimeout: 90000, // ms
    fileDownloadExpiration: 72, // hours
    // FeedbackMail SDK配置
    feedbackSdk: {
        baseUrl: 'https://feedback.gopiqiu.com',
        apiKey: '49b7ea3430964b302dc73ff08a42c6590b7547e99d11ab3fd607801edc337c8b',
        websiteName: 'thesis_formatter',
        buttonIcon: '💬',
        buttonText: '意见反馈',
        position: 'bottom-right',
        timeout: 45,
        language: 'zh',
        debug: false
    },
    // Feature flags
    features: {
        advancedProcessing: true,
        debugPanel: false,
        testingTools: false,
    }
};
